const Login = {
    username: '',
    password: ''
}

export default Login;